export class CreditRequestRequirement {
  number: string;
  refNumber:string;
  name: string;
  area: string;
  description: string;
  type: string;
  attachment: boolean;
  requester: string;
  date: string;
  confirmationDate: string;
  notes: string;
  completedBy: string;
  completedByName: string;
  category: number;
  createdTimezoneDate:Date;
  confirmationDateTimezoneDate:Date;
  status:string;

  constructor() {
    this.number = '';
    this.name = '';
    this.area = '';
    this.description = '';
    this.type = '';
    this.attachment = false;
    this.requester = '';
    this.createdTimezoneDate = new Date();
    this.confirmationDateTimezoneDate = new Date();
    this.notes = '';
    this.completedBy = '';
    this.completedByName = '';
    this.category = 0;
    this.date = '';
    this.confirmationDate = '';
    this.status = '';
    this.refNumber = '';
  }
}
